module.exports = __webpack_public_path__ + "img/wall-port.def14075.png";